var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('navbar'),_c('v-container',[_c('v-row',_vm._l((_vm.plans_abonnements),function(plan){return _c('v-col',{key:plan.id,attrs:{"cols":"12","md":"4"}},[_c('card-abonnement',{attrs:{"plan_abonnement":plan}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }